import { render, staticRenderFns } from "./inventory-foot.vue?vue&type=template&id=450391d5&"
import script from "./inventory-foot.vue?vue&type=script&lang=js&"
export * from "./inventory-foot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports